import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const toWebp = (src) => src.replace(/\.(jpg|jpeg|png)$/i, ".webp");

const Intro = ({ data }) => {
    const imgSrc = process.env.PUBLIC_URL + data.backgroundImage;
    const webpSrc = process.env.PUBLIC_URL + toWebp(data.backgroundImage);

    return (
        <div
            className="single-slider d-flex align-items-center animation-style-01"
            style={{
                backgroundImage: [`url("${webpSrc}")`, `url("${imgSrc}")`].join(
                    ", "
                ),
            }}
        >
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>

            <div className="container">
                <div className="slider-content">
                    <h4 className="sub-title">{data.subTitle}</h4>
                    <h2
                        className="main-title"
                        dangerouslySetInnerHTML={{ __html: data.title }}
                    ></h2>
                    <p dangerouslySetInnerHTML={{ __html: data.desc }}></p>
                    <Link
                        className="slider-btn"
                        to={process.env.PUBLIC_URL + (data.path || "/project")}
                    >
                        {data.btnText || "See project"}
                    </Link>
                </div>
            </div>
        </div>
    );
};

Intro.propTypes = {
    data: PropTypes.object,
};

export default Intro;
